export enum EnvelopeEditTabs {
  Information = 0,
  Signatory = 1,
}
